import { useState, useEffect } from "react";
import API_BASE_URL from "../config";

const Icons = {
  Package: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zM16 3H8a2 2 0 00-2 2v2h12V5a2 2 0 00-2-2z" />
    </svg>
  ),
  Layers: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
    </svg>
  ),
  CheckCircle: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  Tag: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5a2 2 0 011.414.586l7 7a2 2 0 010 2.828l-5 5a2 2 0 01-2.828 0l-7-7A2 2 0 013 9V5a2 2 0 012-2z" />
    </svg>
  ),
  Search: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  ),
  Refresh: ({ spin }) => (
    <svg style={{ animation: spin ? "spin .7s linear infinite" : "none" }} width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
    </svg>
  ),
  AlertCircle: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  Inbox: () => (
    <svg width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
    </svg>
  ),
  CheckBadge: () => (
    <svg width="10" height="10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
    </svg>
  ),
  Warning: () => (
    <svg width="10" height="10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
    </svg>
  ),
  XCircle: () => (
    <svg width="10" height="10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
};

const getStockBadge = (availableQty) => {
  if (availableQty <= 0)
    return (
      <span style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 10px", borderRadius: 99, fontSize: ".78rem", fontWeight: 600, background: "#fee2e2", color: "#991b1b", border: "1px solid #fecaca" }}>
        <Icons.XCircle /> Out of stock
      </span>
    );
  if (availableQty < 10)
    return (
      <span style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 10px", borderRadius: 99, fontSize: ".78rem", fontWeight: 600, background: "#fef9c3", color: "#854d0e", border: "1px solid #fde68a" }}>
        <Icons.Warning /> Low stock
      </span>
    );
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 10px", borderRadius: 99, fontSize: ".78rem", fontWeight: 600, background: "#d1fae5", color: "#065f46", border: "1px solid #a7f3d0" }}>
      <Icons.CheckBadge /> In stock
    </span>
  );
};

const StatCard = ({ icon, label, value, valueColor }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "16px 20px", borderRight: "1px solid #f1f5f9" }}>
    <div style={{ width: 36, height: 36, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", background: "#f8fafc", border: "1px solid #e2e8f0", flexShrink: 0 }}>
      {icon}
    </div>
    <div>
      <p style={{ fontSize: ".65rem", fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".08em", margin: "0 0 2px" }}>{label}</p>
      <p style={{ fontSize: "1.25rem", fontWeight: 800, color: valueColor, margin: 0, fontVariantNumeric: "tabular-nums" }}>{value}</p>
    </div>
  </div>
);

// ── ITEMS_API same as Items Maintenance ──────────────────────────────────────
const ITEMS_API = `${API_BASE_URL}api/Marketing_items`;

export default function Inventory_Marketing_PAGE() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [refreshing, setRefreshing] = useState(false);
  const [filterStatus, setFilterStatus] = useState("all"); // all | active | inactive

  const fetchItems = async (isRefresh = false) => {
    if (isRefresh) setRefreshing(true);
    else setLoading(true);
    setError(null);
    try {
      const res = await fetch(ITEMS_API);
      if (!res.ok) throw new Error(`Server error ${res.status}`);
      const data = await res.json();
      setItems(data);
    } catch (err) {
      setError(err.message || "Failed to load items.");
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => { fetchItems(); }, []);

  // ── Filter ────────────────────────────────────────────────────────────────
  const filtered = items.filter((item) => {
    const q = search.toLowerCase();
    const matchSearch =
      !q ||
      item.itemCode?.toLowerCase().includes(q) ||
      item.description?.toLowerCase().includes(q) ||
      item.category?.toLowerCase().includes(q) ||
      item.unit?.toLowerCase().includes(q) ||
      item.remarks?.toLowerCase().includes(q);

    const matchStatus =
      filterStatus === "all" ||
      (filterStatus === "active" && item.isActive === 1) ||
      (filterStatus === "inactive" && item.isActive !== 1);

    return matchSearch && matchStatus;
  });

  // ── Stats ─────────────────────────────────────────────────────────────────
  const totalItems     = items.length;
  const totalQty       = items.reduce((s, i) => s + (i.qty || 0), 0);
  const totalAvailable = items.reduce((s, i) => s + (i.availableQty || 0), 0);
  const totalActive    = items.filter(i => i.isActive === 1).length;

  return (
    <div style={{ minHeight: "100vh", background: "#f1f5f9", fontFamily: '"Inter", -apple-system, sans-serif', padding: "2rem 1.5rem" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        @keyframes spin { 0%{transform:rotate(0deg)} 100%{transform:rotate(360deg)} }
        @keyframes fadeIn { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
        .inv-row:hover td { background: #eff6ff !important; }
        .inv-row td { transition: background .12s; }
      `}</style>

      <div style={{ maxWidth: 1700, margin: "0 auto", display: "flex", flexDirection: "column", gap: 16 }}>

        {/* ── Header Card ── */}
        <div style={{ background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,.06)" }}>

          {/* Top Bar */}
          <div style={{ background: "#185FA5", padding: "14px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <h1 style={{ color: "#fff", fontWeight: 700, fontSize: "1rem", margin: 0, display: "flex", alignItems: "center", gap: 8 }}>
              <Icons.Package /> Inventory
            </h1>
            <span style={{ fontSize: ".75rem", background: "rgba(255,255,255,.15)", color: "#bfdbfe", border: "1px solid rgba(255,255,255,.2)", padding: "2px 12px", borderRadius: 99, letterSpacing: ".06em" }}>
              Marketing
            </span>
          </div>

          {/* Stats */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", borderBottom: "1px solid #f1f5f9" }}>
            <StatCard icon={<span style={{ color: "#185FA5" }}><Icons.Layers /></span>}       label="Total Items"      value={totalItems.toLocaleString()}     valueColor="#185FA5" />
            <StatCard icon={<span style={{ color: "#64748b" }}><Icons.Package /></span>}      label="Total Qty"        value={totalQty.toLocaleString()}        valueColor="#0f172a" />
            <StatCard icon={<span style={{ color: "#1D9E75" }}><Icons.CheckCircle /></span>}  label="Available"        value={totalAvailable.toLocaleString()}  valueColor="#1D9E75" />
            <StatCard icon={<span style={{ color: "#BA7517" }}><Icons.Tag /></span>}          label="Active Items"     value={totalActive.toLocaleString()}     valueColor="#BA7517" />
          </div>

          {/* Toolbar */}
          <div style={{ padding: "12px 20px", display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            {/* Search */}
            <div style={{ position: "relative", flex: 1, maxWidth: 340 }}>
              <span style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", display: "flex" }}>
                <Icons.Search />
              </span>
              <input
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search item code, description, category…"
                style={{ width: "100%", paddingLeft: 34, paddingRight: 12, height: 36, border: "1px solid #e2e8f0", borderRadius: 8, fontSize: ".85rem", color: "#1e293b", outline: "none", fontFamily: "inherit", boxSizing: "border-box" }}
              />
            </div>

            {/* Status Filter */}
            <select
              value={filterStatus}
              onChange={e => setFilterStatus(e.target.value)}
              style={{ height: 36, padding: "0 12px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: ".85rem", color: "#475569", fontFamily: "inherit", background: "#fff", cursor: "pointer" }}
            >
              <option value="all">All Status</option>
              <option value="active">Active Only</option>
              <option value="inactive">Inactive Only</option>
            </select>

            {/* Refresh */}
            <button
              onClick={() => fetchItems(true)}
              disabled={refreshing}
              style={{ display: "flex", alignItems: "center", gap: 6, height: 36, padding: "0 14px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: ".85rem", color: "#475569", fontWeight: 600, background: "#fff", cursor: refreshing ? "not-allowed" : "pointer", opacity: refreshing ? .5 : 1, fontFamily: "inherit" }}
            >
              <Icons.Refresh spin={refreshing} />
              {refreshing ? "Refreshing…" : "Refresh"}
            </button>

            <span style={{ marginLeft: "auto", fontSize: ".78rem", color: "#94a3b8" }}>
              {filtered.length} of {items.length} item{items.length !== 1 ? "s" : ""}
            </span>
          </div>
        </div>

        {/* ── Table Card ── */}
        <div style={{ background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,.06)" }}>

          {/* Error */}
          {error && (
            <div style={{ background: "#fef2f2", borderBottom: "1px solid #fecaca", color: "#b91c1c", padding: "10px 20px", fontSize: ".85rem", display: "flex", alignItems: "center", gap: 8 }}>
              <Icons.AlertCircle /> {error}
              <button onClick={() => fetchItems()} style={{ marginLeft: "auto", color: "#ef4444", fontWeight: 600, fontSize: ".8rem", textDecoration: "underline", background: "none", border: "none", cursor: "pointer" }}>Retry</button>
            </div>
          )}

          {loading ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "6rem", gap: 12, color: "#94a3b8" }}>
              <svg style={{ animation: "spin .7s linear infinite", width: 24, height: 24 }} fill="none" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" style={{ opacity: .25 }} />
                <path fill="currentColor" d="M4 12a8 8 0 018-8v8z" style={{ opacity: .75 }} />
              </svg>
              <span style={{ fontSize: ".9rem" }}>Loading items…</span>
            </div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                    {[
                      { label: "#",             w: 50  },
                      { label: "Item Code",      w: 130 },
                      { label: "Description",    w: 260 },
                      { label: "Qty",            w: 100 },
                      { label: "Available Qty",  w: 120 },
                      { label: "Unit",           w: 80  },
                      { label: "Category",       w: 120 },
                      { label: "Stock Status",   w: 130 },
                      { label: "Active",         w: 90  },
                      { label: "Remarks",        w: 160 },
                    ].map(({ label, w }) => (
                      <th key={label} style={{ textAlign: "left", padding: "11px 16px", fontSize: ".7rem", fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".07em", whiteSpace: "nowrap", width: w }}>
                        {label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.length === 0 ? (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center", padding: "5rem", color: "#94a3b8", fontSize: ".9rem" }}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8, color: "#cbd5e1" }}>
                          <Icons.Inbox />
                          <span style={{ color: "#94a3b8" }}>{search ? "No items match your search." : "No items found."}</span>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    filtered.map((item, idx) => (
                      <tr key={item.id} className="inv-row" style={{ animation: "fadeIn .2s ease both", animationDelay: `${Math.min(idx * 20, 200)}ms` }}>
                        {/* # */}
                        <td style={{ padding: "11px 16px", color: "#cbd5e1", fontFamily: "monospace", fontSize: ".78rem", borderBottom: "1px solid #f1f5f9" }}>
                          {idx + 1}
                        </td>

                        {/* Item Code */}
                        <td style={{ padding: "11px 16px", fontFamily: "monospace", fontSize: ".8rem", fontWeight: 700, color: "#185FA5", borderBottom: "1px solid #f1f5f9" }}>
                          {item.itemCode}
                        </td>

                        {/* Description */}
                        <td style={{ padding: "11px 16px", color: "#334155", fontSize: ".875rem", borderBottom: "1px solid #f1f5f9", maxWidth: 260 }}>
                          {item.description || <span style={{ color: "#cbd5e1" }}>—</span>}
                        </td>

                        {/* Qty */}
                        <td style={{ padding: "11px 16px", fontWeight: 600, color: "#0f172a", fontSize: ".85rem", textAlign: "right", borderBottom: "1px solid #f1f5f9", fontVariantNumeric: "tabular-nums" }}>
                          {Number(item.qty || 0).toLocaleString()}
                        </td>

                        {/* Available Qty */}
                        <td style={{ padding: "11px 16px", fontWeight: 700, fontSize: ".85rem", textAlign: "right", color: item.availableQty > 0 ? "#1D9E75" : "#E24B4A", borderBottom: "1px solid #f1f5f9", fontVariantNumeric: "tabular-nums" }}>
                          {Number(item.availableQty || 0).toLocaleString()}
                        </td>

                        {/* Unit */}
                        <td style={{ padding: "11px 16px", borderBottom: "1px solid #f1f5f9" }}>
                          {item.unit
                            ? <span style={{ display: "inline-block", background: "#f1f5f9", color: "#64748b", fontSize: ".75rem", fontFamily: "monospace", fontWeight: 600, padding: "2px 8px", borderRadius: 6, border: "1px solid #e2e8f0" }}>{item.unit}</span>
                            : <span style={{ color: "#cbd5e1" }}>—</span>
                          }
                        </td>

                        {/* Category */}
                        <td style={{ padding: "11px 16px", color: "#475569", fontSize: ".85rem", borderBottom: "1px solid #f1f5f9" }}>
                          {item.category || <span style={{ color: "#cbd5e1" }}>—</span>}
                        </td>

                        {/* Stock Status */}
                        <td style={{ padding: "11px 16px", borderBottom: "1px solid #f1f5f9" }}>
                          {getStockBadge(item.availableQty)}
                        </td>

                        {/* Active */}
                        <td style={{ padding: "11px 16px", borderBottom: "1px solid #f1f5f9" }}>
                          <span style={{
                            display: "inline-block", padding: "2px 10px", borderRadius: 99, fontSize: ".75rem", fontWeight: 600,
                            background: item.isActive === 1 ? "#d1fae5" : "#f1f5f9",
                            color: item.isActive === 1 ? "#065f46" : "#94a3b8",
                            border: `1px solid ${item.isActive === 1 ? "#a7f3d0" : "#e2e8f0"}`,
                          }}>
                            {item.isActive === 1 ? "Active" : "Inactive"}
                          </span>
                        </td>

                        {/* Remarks */}
                        <td style={{ padding: "11px 16px", color: "#94a3b8", fontSize: ".8rem", borderBottom: "1px solid #f1f5f9", maxWidth: 160 }}>
                          {item.remarks || <span style={{ color: "#e2e8f0" }}>—</span>}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* Footer */}
          {!loading && filtered.length > 0 && (
            <div style={{ borderTop: "1px solid #f1f5f9", padding: "10px 20px", display: "flex", alignItems: "center", gap: 20, fontSize: ".75rem", color: "#94a3b8", background: "#f8fafc", flexWrap: "wrap" }}>
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#1D9E75", display: "inline-block" }} />
                Available = ready to use
              </span>
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#E24B4A", display: "inline-block" }} />
                Out of stock = availableQty ≤ 0
              </span>
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#BA7517", display: "inline-block" }} />
                Low stock = availableQty &lt; 10
              </span>
              <span style={{ marginLeft: "auto" }}>
                Showing {filtered.length} of {items.length} items
              </span>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}